import type { Diagnostics } from '@/diagnostic/domain/Diagnostics.ts';
import type { ApiInformationToDiagnose } from '@/diagnostic/domain/ApiInformation.ts';
import type { Diagnostic } from '@/diagnostic/domain/Diagnostic.ts';
import { DiagnosticCompleted } from '@/diagnostic/domain/Diagnostic.ts';
import type { DiagnosticFollowUp } from '@/diagnostic/domain/DiagnosticFollowUp.ts';
import type { DiagnosticId } from '@/diagnostic/domain/DiagnosticId.ts';

export type DiagnosticListener = (diagnostic: Diagnostic) => void;

export class DiagnoseDiagnostic {
  readonly #diagnostics: Diagnostics;

  constructor(diagnostics: Diagnostics) {
    this.#diagnostics = diagnostics;
  }

  async diagnose(
    api: ApiInformationToDiagnose,
    listener: DiagnosticListener,
    onStarted?: (id: DiagnosticId) => void,
  ): Promise<DiagnosticFollowUp> {
    const id = await this.#diagnostics.diagnose(api);
    onStarted?.(id);

    return this.resume(id, listener);
  }

  resume(id: DiagnosticId, listener: DiagnosticListener): DiagnosticFollowUp {
    const followUp: DiagnosticFollowUp = this.#diagnostics.listen(id)((diagnostic) => {
      listener(diagnostic);

      if (diagnostic instanceof DiagnosticCompleted) {
        followUp.stop();
        this.#diagnostics.notifyDiagnosticCompleted();
      }
    });

    return followUp;
  }
}
